import React from "react";
import moment from "moment";
import FormField from "@modules/formx-react/FormField";
import DatePicker, { DatePickerProps } from "../DatePicker";

export type Time2Props = {
  name: string;
  label?: string;
  DatePickerProps?: Partial<DatePickerProps>;
  disabled?: boolean;
  momentFormat?: string;
};

export function Time2(props: Time2Props) {
  const { name, label, DatePickerProps: datePickerProps, momentFormat = "HH:mm" } = props;

  return (
    <FormField name={name}>
      {(field) => {
        const disabled = props.disabled || field.disabled;
        const value = field.value ? moment.utc(field.value, momentFormat) : null;

        return (
          <DatePicker
            {...field.fieldProps}
            name={name}
            label={field.error || label}
            value={value}
            error={field.invalid && !field.disabled}
            showTimeSelect
            showTimeSelectOnly
            dateFormat={momentFormat}
            onChange={(v) => {
              if (!v) {
                field.value = "";
                return;
              }

              field.value = v.format(momentFormat);
            }}
            {...datePickerProps}
            disabled={disabled}
          />
        );
      }}
    </FormField>
  );
}
